import React from 'react';
import { Building2, Mail, Phone, MapPin, CreditCard, Tag, Globe } from 'lucide-react';
import type { B2BBuyer } from '../../types/b2b';

interface BuyerProfileSummaryProps {
  buyer: B2BBuyer;
}

export const BuyerProfileSummary: React.FC<BuyerProfileSummaryProps> = ({ buyer }) => {
  const statusColors: Record<string, string> = {
    active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    pending_approval: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    blocked: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    suspended: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  };

  return (
    <div className="card p-4">
      <div className="flex flex-wrap items-start gap-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100">{buyer.trade_name}</h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 font-mono">{buyer.buyer_code}</p>
          </div>
        </div>
        <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${statusColors[buyer.account_status] || ''}`}>
          {buyer.account_status.replace('_', ' ')}
        </span>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600 dark:text-gray-400">
          {buyer.vat_number && (
            <span className="flex items-center gap-1.5"><Tag className="h-3.5 w-3.5" /> VAT: {buyer.vat_number}</span>
          )}
          <span className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> {buyer.email}</span>
          {buyer.phone && (
            <span className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5" /> {buyer.phone}</span>
          )}
          {buyer.shipping_city && (
            <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {buyer.shipping_city}{buyer.shipping_country ? `, ${buyer.shipping_country}` : ''}</span>
          )}
          {buyer.payment_terms && (
            <span className="flex items-center gap-1.5"><CreditCard className="h-3.5 w-3.5" /> {buyer.payment_terms}</span>
          )}
          <span className="flex items-center gap-1.5"><Globe className="h-3.5 w-3.5" /> Discount: ÷{buyer.account_discount}</span>
        </div>
      </div>
    </div>
  );
};
